import { render, staticRenderFns } from "./aComplaintDetailType.vue?vue&type=template&id=df1066a2&scoped=true"
import script from "./aComplaintDetailType.vue?vue&type=script&lang=js"
export * from "./aComplaintDetailType.vue?vue&type=script&lang=js"
import style0 from "./aComplaintDetailType.vue?vue&type=style&index=0&id=df1066a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1066a2",
  null
  
)

export default component.exports